export class Errors {
  static ERRORS = {
    'file.not-found': "Le fichier n'a pas été trouvé",
    'mail.already-used':
      'Cette adresse mail est déjà utilisée, veuillez en choisir une autre',
    'enterprise.not-found': 'Aucune entreprise trouvée',
    'administrator.not-found': "Gestionnaire d'entreprise introuvable",
    'administrator-mail.not-found': 'Aucun mail trouvé sur le gestionnaire',
    default: "Une erreur s'est produite",
    'password.invalid': 'Mot de passe incorrect',
    'password-minlength': 'Le mot de passe est inférieur à 12 caractères',
    'password-lowercase': 'Le mot de passe ne contient pas de minuscule',
    'password-uppercase': 'Le mot de passe ne contient pas de majuscule',
    'password-digit': 'Le mot de passe ne contient pas de chiffre',
    'password-specialchar':
      'Le mot de passe ne contient pas de caractère spécial',
    'not-found': 'Demande non trouvée',
    'id.not-found': 'La ressource recherchée ne semble pas exister',
    'document.already-shared':
      'Un ou plusieurs document(s) de votre envoi ont déjà été envoyés à cet assuré.',
    'document.warranty-readonly':
      'Ce document ne peut pas être modifié ou supprimé.',
    'document.enterprise-required':
      "Une entreprise doit être sélectionnée pour télécharger ce document.",
    'mail.not-admin':
      "L'email saisi ne correspond pas à un administrateur de cette entreprise, veuillez vérifier l'adresse email saisie ou contacter votre mutuelle.",
    'user.already-enterprise-user':
      'Cet utilisateur a déjà accès à cette entreprise.',
    'user.already-mutuelle-user':
      'Cet utilisateur est déjà un utilisateur mutuelle.',
    'user.missing-enterprise-id': "L'identifiant de l'entreprise est requis.",
    'user.cannot-create-admin-user':
      "Vous ne pouvez pas créer d'utilisateur admin",
    'user.not-found': 'Utilisateur introuvable',
    'user.readonly':
      'Vous ne disposez pas des droits nécessaires pour effectuer cette action',
    'user.cannot-update-mutuelle-user':
      'Vous ne pouvez pas modifier un utilisateur mutuelle',
    'user.cannot-delete-mutuelle-user':
      'Vous ne pouvez pas supprimer un utilisateur mutuelle',
    'user.user-from-another-enterprise':
      "Cet utilisateur n'appartient pas à l'entreprise sélectionnée",
    'user.insufficient-role':
      "Vous ne disposez pas des droits suffisants pour gérer cet utilisateur",
    'user.cannot-delete-self':
      'Vous ne pouvez pas supprimer votre propre compte',
    'identifier.already-used':
      'Cet identifiant est déjà utilisé pour un compte existant.',
    'identity.mismatch':
      'Veuillez vérifier les informations saisies, elles ne correspondent pas à celles enregistrées.',
    'user.email-not-found':
      "Aucune adresse email n'a été trouvée pour ce numéro adhérent.",
    'insured.not-found': 'Aucun adhérent trouvé pour ce numéro.',
    'access.denied':
      "Aucun rôle valide n'a été trouvé pour cet adhérent. L'accès est refusé.",
    'phone.not-set':
      "Aucun téléphone professionnel n'est renseigné dans votre dossier pour ce numéro adhérent. Contactez votre mutuelle.",
    'phone.mismatch':
      'Le téléphone professionnel ne correspond pas au dossier.',
    'registration.not-enabled':
      "Cette inscription n'est pas disponible pour cette mutuelle.",
    'registration.use-self-registration-flow':
      "Utilisez le parcours d'inscription (création de compte) prévu pour votre mutuelle : écran Connexion puis « créer mon accès ».",
    'registration.complete-failed':
      'La création du compte a échoué. Réessayez ou contactez votre mutuelle.',
    'password.match': 'Les mots de passe ne correspondent pas.',
    'token.invalid':
      'Session invalide ou expirée. Recommencez depuis le début.',
    'two-factor.session.invalid': 'Session invalide ou expirée.',
    'two-factor.session.expired': 'La session a expiré. Recommencez.',
    'two-factor.session.too-many-attempts': 'Trop de tentatives. Recommencez.',
    'two-factor.code.invalid': 'Code incorrect.',
    'two-factor.purpose.mismatch': 'Étape invalide.',
    'two-factor.not-verified': 'Étape précédente non validée.',
    'sms.delivery-failed': 'Envoi du SMS impossible. Réessayez plus tard.',
    'sms.config-missing': 'Configuration SMS manquante.',
    'login.2fa.email-missing':
      "Aucune adresse e-mail n'est associée à ce compte pour la vérification. Contactez votre mutuelle.",
    'login.2fa.phone-missing':
      "Aucun numéro de mobile n'est associé à ce compte pour la vérification. Contactez votre mutuelle.",
  };

  static getError(error: any): string {
    const raw =
      typeof error?.error === 'string'
        ? error.error
        : error?.error?.message;
    const apiMessage = Array.isArray(raw)
      ? typeof raw[0] === 'string'
        ? raw[0]
        : null
      : typeof raw === 'string'
        ? raw
        : null;
    const key = apiMessage || error?.message;
    return Errors.ERRORS[key] || Errors.ERRORS['default'];
  }
}
